import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Row, Col, Button, NavLink } from 'reactstrap';
import { useEffect, useReducer, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import qs from 'query-string';

import { ApplicationState } from '../../store';
import * as CartStore from '../../store/Cart';

import { formatMoney, formatUtcDateToLocal } from '../../components/shared/Utils';
import { StringUtils } from "../../components/shared/StringUtils";
import Loader from '../../components/shared/Loader';

import { ShoppingCart, ShoppingCartItem, Status } from '../../models/ShoppingCart';

type ReadOnlyCartDetailsState = {
    //step: "overview" | "preview";
    grouppedCartItems: ShoppingCart[];
    cartToSend: ShoppingCart;
}

const initialState: ReadOnlyCartDetailsState = {
    grouppedCartItems: [],
    cartToSend: undefined
}

function ReadOnlyCartDetails(props: {
    grouppedCartItems: ShoppingCart[];
    cartActions: typeof CartStore.actionCreators,
    cartState: CartStore.IState,
}) {

    const history = useHistory();

    let [state, setState] = useReducer(
        (prevState: ReadOnlyCartDetailsState, newState: Partial<ReadOnlyCartDetailsState>) => ({ ...prevState, ...newState }),
        initialState
    );

    function calculatePartnerTotalPrice(cartItems: ShoppingCartItem[]) {
        return cartItems.reduce((acc, val) => acc + val.Amount * val.PricePerUnit, 0);
    }

    function calculatePartnerTotalOldPrice(cartItems: ShoppingCartItem[]) {
        return cartItems.reduce((acc, val) => acc + val.Amount * val.OldPricePerUnit, 0);
    }

    function calculateCartTotal(cart: ShoppingCart) {
        let total = 0;

        const keys = Object.keys(cart.GroupInner);

        keys.map(key => {
            total += calculatePartnerTotalPrice(cart.GroupInner[key]);

            return key;
        });

        return total;
    }

    //useEffect(() => {
    //    groupCartItemByPartner(props.cartState.shoppingCartDetails);

    //}, [props.cartState.shoppingCartDetails]);

    const groupCartItemByPartner = (cart: ShoppingCart) => {
        let groupedByCart: ShoppingCart[] = [];

        if (cart && cart.Items) {
            const groupInner: Record<string, ShoppingCartItem[]> = cart.Items.reduce((r: Record<string, ShoppingCartItem[]>, a) => {

                r[a.PartnerFormatedName] = r[a.PartnerFormatedName] || [];
                r[a.PartnerFormatedName].push(a);

                return r;

            }, Object.create(null));

            let newCart: ShoppingCart = Object.create(cart);

            newCart.GroupInner = groupInner || {};
            groupedByCart.push(newCart);
        }

        console.log('groupedByCart', groupedByCart);

        setState({ grouppedCartItems: groupedByCart });

        return groupedByCart;
    }

    const copyToClipboard = async (cartId) => {
        if (!navigator.clipboard) {
            console.log("Browser don't have support for native clipboard.");
            toast.error("Don't have support for native clipboard.");
        }
        else {
            await navigator.clipboard.writeText(cartId);
            console.log("Copied!!!");
            toast.success("Cart ID copied to clipboard.");
        }
    }

    const getCartItemPriceClass = (cartItem: ShoppingCartItem) => {
        if (!cartItem.OldPricePerUnit || cartItem.OldPricePerUnit === 0) {
            return "";
        }

        if (!cartItem.PricePerUnit || cartItem.PricePerUnit === 0) {
            return "";
        }

        return getPriceClass(cartItem.PricePerUnit, cartItem.OldPricePerUnit);
    }

    const getCartItemTotalPriceClass = (cartItem: ShoppingCartItem) => {
        if (!cartItem.OldPricePerUnit || cartItem.OldPricePerUnit === 0) {
            return "";
        }

        if (!cartItem.PricePerUnit || cartItem.PricePerUnit === 0) {
            return "";
        }

        return getPriceClass(cartItem.PricePerUnit * cartItem.Amount, cartItem.OldPricePerUnit * cartItem.Amount);
    }

    function getPriceClass(price: number, oldPrice: number) {
        if (oldPrice === 0) {
            return "";
        }

        if (price === 0) {
            return "";
        }

        if (price < oldPrice) {
            return "lower-price";
        }

        if (price > oldPrice) {
            return "higher-price";
        }
    }

    const canCheckout = (items: ShoppingCartItem[]) => {
        const notAvailableItems = items.filter(x => !x.Available);

        return !notAvailableItems || notAvailableItems.length < items.length;
    }

    return <Container className="mt-4">
        {props.grouppedCartItems &&
            <React.Fragment>
                <Row>
                    <Col>
                        <h1>My Cart</h1>
                    </Col>
                    <Col>
                        <div className="d-flex justify-content-end mt-3">
                            <NavLink tag={Link} className="btn btn-primary d-inline-block text-uppercase" to="/">Continue Shopping</NavLink>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        {props.grouppedCartItems && <React.Fragment>
                            {props.grouppedCartItems.map(cart => {

                                const keys = Object.keys(cart.GroupInner);
                                return <div className="cart">
                                    <Row className="align-items-baseline">
                                        <Col>
                                            <div className="cart-header my-4" key={cart.CartId}>
                                                <span className="cart-title fw-semibold">{cart.CartName}</span>
                                                <span className="cart-id mr-2"> <Button color="white" className="btn-pill cart-id" onClick={() => copyToClipboard(cart.CartId)}>Cart ID</Button></span>
                                                <span className="cart-created mr-2">Cart Modified: {formatUtcDateToLocal(cart.CartModified)}</span>
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col>
                                            {(keys || []).map(key => {
                                                const items: ShoppingCartItem[] = cart.GroupInner[key];
                                                const partnerPrice = calculatePartnerTotalPrice(items);
                                                const partnerOldPrice = calculatePartnerTotalOldPrice(items);

                                                return <div className="table-responsive" key={`${cart.CartId} + ${key}`}>
                                                    <table className="table table-bordered-special bg-white table-cart">
                                                        <caption>
                                                            {
                                                                items && items.length > 0 &&
                                                                <div className="d-flex justify-content-between align-items-baseline">
                                                                    <div className="py-2">{items[0].PartnerName}</div>
                                                                    <div className="py-2">
                                                                    </div>
                                                                </div>
                                                            }
                                                        </caption>
                                                        <thead>
                                                            <tr>
                                                                <th>MFR PN</th>
                                                                <th className="text-nowrap">Impact Partner PN</th>
                                                                <th>Description</th>
                                                                <th className="text-center">QTY</th>
                                                                <th>Cost</th>
                                                                <th>Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(items || []).map(x =>
                                                                <tr key={`${x.PartnerId + x.ProductNumber}`} className={x.Available ? '' : "not-available"}>
                                                                    <td className="cell-product-code">
                                                                        <div className="text-nowrap">{x.ProductNumber}</div>
                                                                    </td>
                                                                    <td className="cell-partner-number">
                                                                        <span className="text-nowrap"> {x.PartnerPartNumber}</span>
                                                                    </td>
                                                                    <td className="cell-description">
                                                                        {x.Remanufactured && '[REMANUFACTURED] '} {x.Description}
                                                                    </td>
                                                                    <td className="cell-quantity">
                                                                        <div className="cart-quantity d-flex justify-content-center">
                                                                            <div className="pr-2">{x.Amount}</div>
                                                                            {x.OldAmount > 0 && <div className="underlined-value pr-2">{x.OldAmount}</div>}
                                                                        </div>
                                                                    </td>
                                                                    <td className="cell-cost">
                                                                        {x.OldPricePerUnit && x.OldPricePerUnit > 0 && x.OldPricePerUnit !== x.PricePerUnit &&
                                                                            <div className="text-nowrap underlined-value pr-2">
                                                                                {formatMoney(x.OldPricePerUnit)}
                                                                            </div>
                                                                        }
                                                                        <div className={"text-nowrap " + getCartItemPriceClass(x)}>
                                                                            {x.PricePerUnit > 0 ? formatMoney(x.PricePerUnit) : "$--.--"}
                                                                        </div>
                                                                    </td>
                                                                    <td className="cell-total">
                                                                        {x.OldPricePerUnit && x.OldPricePerUnit > 0 && x.OldPricePerUnit !== x.PricePerUnit &&
                                                                            <div className="text-nowrap underlined-value pr-2">
                                                                                {formatMoney(x.OldPricePerUnit * x.Amount)}
                                                                            </div>
                                                                        }
                                                                        <div className={"text-nowrap " + getCartItemTotalPriceClass(x)}>
                                                                            {x.PricePerUnit > 0 ? formatMoney(x.PricePerUnit * x.Amount) : "$--.--"}
                                                                        </div>
                                                                    </td>
                                                                </tr>)}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan={5} className="subtotal-label text-right lead fw-bold">Subtotal</td>
                                                                <td className="subtotal-value">
                                                                    {
                                                                        partnerOldPrice > 0 && partnerOldPrice !== partnerPrice &&
                                                                        <div className="text-nowrap underlined-value pr-2">
                                                                            {formatMoney(partnerOldPrice)}
                                                                        </div>
                                                                    }
                                                                    <div className={"text-nowrap " + getPriceClass(partnerPrice, partnerOldPrice)}>
                                                                        {formatMoney(partnerPrice)}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            }
                                            )}
                                        </Col>
                                    </Row>
                                    {cart.Items.length > 0 &&
                                        <React.Fragment>
                                            <Row>
                                                <Col></Col>
                                                <Col>
                                                    <div className="d-flex justify-content-end align-items-baseline">
                                                        <span className="summary-total-label mr-3">Cart Total:</span>
                                                        <span className="summary-total-value">{formatMoney(calculateCartTotal(cart))}</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                </Col>

                                                <Col>
                                                    <div className="d-flex justify-content-end">
                                                        {cart.Status === Status.None && <>
                                                            {props.cartState.cartSending && <span className="mt-3 mr-3"><Loader /></span>}
                                                            <Button color="primary" className="text-uppercase mt-2 mb-2" disabled={!canCheckout(cart.Items) || props.cartState.cartSending}
                                                                onClick={() => { setState({ cartToSend: cart }); props.cartActions.sendCartOrder(cart) }}>Send Order</Button>

                                                        </>
                                                        }

                                                        {cart.Status === Status.Confirmed && <>
                                                            <Button color="primary" className="text-uppercase mt-2 mb-2" disabled={!canCheckout(cart.Items)}
                                                                onClick={() => { props.cartActions.setShoppinCart(cart); history.push("/checkout"); }}>Checkout</Button>
                                                        </>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        </React.Fragment>
                                    }
                                    {cart.Items.length === 0 &&
                                        <React.Fragment>
                                            <Row>
                                                <Col><div className="no-results-found">Your shopping cart is empty</div></Col>
                                            </Row>
                                        </React.Fragment>
                                    }
                                </div>
                            }
                            )}
                        </React.Fragment>}
                    </Col>
                </Row>
            </React.Fragment>
        }
        {
            !props.grouppedCartItems || props.grouppedCartItems.length === 0 && <Row className="">
                <Col>
                    <div className="no-results-found">Your shopping cart is empty</div>
                </Col>
            </Row>
        }
    </Container>
}

export default connect((state: ApplicationState) => ({
    cartState: state.cart
}), // Selects which state properties are merged into the component's props
    (dispatch, getState) => ({
        cartActions: bindActionCreators(CartStore.actionCreators, dispatch)
    }))(ReadOnlyCartDetails);

